import React from "react";
import { statusCategoryIcons } from "../../../../../Findings/FindingDetailsPane/FindingDetailsPaneHeader/Statuses/StatusUtils";
import "./FindingStatusLogo.scss";
import { Tooltip } from "@SeemplicityDev/shared";

interface FindingStatusLogoProps {
  category?: string;
  label?: string;
}

const FindingStatusLogo: React.FC<FindingStatusLogoProps> = ({
  category,
  label,
}) => {
  return (
    <div
      className={"finding-status-logo-wrapper"}
      data-testid={`finding-status-${category?.toLowerCase()}`}
    >
      <div
        className={`finding-status-logo finding-status-logo-${category?.toLowerCase()}`}
      >
        <i
          className={`seem-icon ${
            category
              ? ((statusCategoryIcons as Record<string, string>)[category] ??
                "")
              : ""
          }`}
        />
      </div>
      {label && (
        <Tooltip content={label}>
          <div className={"finding-status-label"}>{label}</div>
        </Tooltip>
      )}
    </div>
  );
};

export default FindingStatusLogo;
